import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { FaApple, FaAndroid, FaWindows, FaLinux, FaGlobe } from "react-icons/fa";
import "./PlatformsSection.scss";

const platforms = [
  { icon: <FaGlobe />,   key: "web",     badge: true,  badgeColor: "#2563eb", color: "#2563eb", bg: "#eff6ff" },
  // desktop app ("PC"): Windows + Linux logos side by side in a wider tile
  { icon: <><FaWindows /><FaLinux /></>, key: "windows", wide: true, badge: false, color: "#0284c7", bg: "#f0f9ff" },
  { icon: <FaAndroid />, key: "android", badge: false, color: "#16a34a", bg: "#f0fdf4" },
  { icon: <FaApple />,   key: "ios",     badge: false, color: "#374151", bg: "#f9fafb" },
];

const PlatformsSection = () => {
  const { t, i18n } = useTranslation();

  return (
    <section className="syd-platforms" id="devices">
      <div className="syd-platforms__bg" aria-hidden="true">
        <div className="syd-platforms__bg-orb syd-platforms__bg-orb--1" />
        <div className="syd-platforms__bg-orb syd-platforms__bg-orb--2" />
      </div>
      <div className="container">
        <motion.div
          className="syd-platforms__header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="syd-platforms__label">{t("landing.platforms.label")}</div>
          <h2 className="syd-platforms__title">
            {t("landing.platforms.title")}
          </h2>
          <span className="syd-platforms__underline" aria-hidden="true" />
          <p className="syd-platforms__sub">
            {t("landing.platforms.sub")}
          </p>
        </motion.div>

        <div className="syd-platforms__grid">
          {platforms.map((p, i) => (
            <motion.div
              className={`syd-platform-card${p.badge ? " syd-platform-card--featured" : ""}`}
              key={i}
              style={{ "--accent": p.color, "--accent-bg": p.bg }}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              viewport={{ once: true }}
            >
              {p.badge && (
                <div
                  className="syd-platform-card__badge"
                  style={{ background: p.badgeColor }}
                >
                  {t("landing.platforms.recommended")}
                </div>
              )}
              <div className={`syd-platform-card__icon${p.wide ? " syd-platform-card__icon--wide" : ""}`}>{p.icon}</div>
              <h3 className="syd-platform-card__name">{t(`landing.platforms.${p.key}_name`)}</h3>
              <p className="syd-platform-card__desc">{t(`landing.platforms.${p.key}_desc`)}</p>
              {p.key === "android" || p.key === "ios" ? (
                <span className="syd-platform-card__link syd-platform-card__link--soon">
                  {t("landing.platforms.coming_soon")}
                </span>
              ) : p.key === "windows" ? (
                <NavLink to={`/${i18n.language}/desktop`} className="syd-platform-card__link">
                  {t("landing.platforms.download")} →
                </NavLink>
              ) : (
                // the web app needs no download: open it
                <NavLink to={`/${i18n.language}/login`} className="syd-platform-card__link">
                  {t("landing.nav.login")} →
                </NavLink>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformsSection;
